import { render } from "./LoginBridgeView.vue?vue&type=template&id=950de3dc&scoped=true"
import script from "./LoginBridgeView.vue?vue&type=script&lang=js"
export * from "./LoginBridgeView.vue?vue&type=script&lang=js"

import "./LoginBridgeView.vue?vue&type=style&index=0&id=950de3dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-950de3dc"]])

export default __exports__